module.exports = __webpack_public_path__ + "static/media/YF105_2.05ef6f25.jpg";